/*
 * Author: Raul Perusquia <raul@inikoo.com>
 * Created: Fri, 08 Dec 2023 01:34:47 Malaysia Time, Kuala Lumpur, Malaysia
 * Copyright (c) 2023, Raul A Perusquia Flores
 */

import { useMilisecondToTime } from "@/Composables/useFormatTime"
import { differenceInMilliseconds } from 'date-fns'
import { defineStore } from "pinia";

interface ProgressBar {
    [key: string]: {
        [key: string]: {
            action_id: number
            action_type: string
            data: {
                number_fails: number
                number_success: number
            },
            done: number
            total: number
        }
    }
}

export const useEchoRetinaPersonal = defineStore("echo-retina-personal", {
    state: () => ({
        progressBars: {} as ProgressBar,
        isShowProgress: false,
        recentlyUploaded: [],
        ticketBadges: null as null | { mine: Record<string, { label: string; count: number }>; recent: { id: string; title: string; body: string; route: string; read: boolean; created_at: string }[] }
    }),
    actions: {
        subscribe(webUserID: number) {
            window.Echo.private("retina.personal." + webUserID).listen(".ticket-badges-update", (eventData: { ticket_badges: any }) => {
                this.ticketBadges = eventData.ticket_badges
            })
             window.Echo.private("retina.personal." + webUserID).listen(
                ".action-progress",
                (eventData) => {

                    // Update the state
                    this.$patch({
                        progressBars: {
                            [eventData.action_type]: {
                                [eventData.action_id]: {
                                    ...eventData,
                                    time_echo: new Date(),
                                    estimatedTime: useMilisecondToTime(differenceInMilliseconds(new Date(), this.progressBars?.[eventData.action_type]?.[eventData.action_id]?.time_echo ?? new Date()) * (eventData.total-eventData.done))
                                    // useEstimatedTime(new Date(), (this.progressBars?.[eventData.action_type]?.[eventData.action_id]?.time_echo ?? 0))
                                }
                            }
                        }
                    })

                    // console.log(this.progressBars[eventData.action_type][eventData.action_id].estimatedTime)

                    // To show the progress bars
                    if(!this.isShowProgress && eventData.action_type === 'Upload') this.isShowProgress = true

                    // If already reach 100%
                    if(eventData.done >= eventData.total){
                        // Add data to recentlyUploaded, to show in history
                        this.recentlyUploaded.push(this.progressBars[eventData.action_type][eventData.action_id])

                        if (eventData.action_type === 'Upload' && eventData.data?.number_fails > 0) return

                        setTimeout(() => {
                            delete this.progressBars[eventData.action_type][eventData.action_id]

                            // If no more progress, then hide the bar
                            const uploadCount = Object.values(this.progressBars[eventData.action_type])
                            if(!uploadCount.length) this.isShowProgress = false
                        }, 4000)
                    }
                }
            );

        },
    },
});
